import React from "react";
import "./niveles.css";

class Item extends React.Component {
  render() {
    return (
      <div {...this.props}>
        {this.props.item && (
          <div onClick={this.props.onClick} className="containerItemNivel sortable-list">
            <div className="imgNombre">
              {this.props.item.imagen !== undefined && <img src={this.props.item.imagen} alt="" />}
              <div>{this.props.item.descripcion}</div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default Item;
